/**
 * StatsBar
 * Displays meeting statistics and key metrics
 */

import React from 'react';
import { Calendar, FileText, CheckSquare, Clock } from 'lucide-react';
import { MeetingStats } from '../../../types';
import styles from './StatsBar.module.css';

export interface StatsBarProps {
  stats: MeetingStats;
  loading?: boolean;
}

export const StatsBar: React.FC<StatsBarProps> = ({ stats, loading = false }) => {
  const statItems = [
    {
      icon: Calendar,
      label: 'Total Meetings',
      value: stats.totalMeetings,
      color: 'blue',
    },
    {
      icon: FileText,
      label: 'MoMs Generated',
      value: stats.momsGenerated,
      color: 'green',
    },
    {
      icon: CheckSquare,
      label: 'Stories Created',
      value: stats.storiesCreated,
      color: 'purple',
    },
    {
      icon: Clock,
      label: 'Pending Reviews',
      value: stats.pendingReviews,
      color: 'orange',
    },
  ];

  if (loading) {
    return (
      <div className={styles.statsBar}>
        {statItems.map((item, index) => (
          <div key={index} className={styles.statCard}>
            <div className={styles.skeleton} />
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className={styles.statsBar}>
      {statItems.map((item, index) => {
        const Icon = item.icon;
        return (
          <div key={index} className={`${styles.statCard} ${styles[item.color]}`}>
            <div className={styles.statIcon}>
              <Icon size={24} />
            </div>
            <div className={styles.statContent}>
              <div className={styles.statValue}>{item.value}</div>
              <div className={styles.statLabel}>{item.label}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StatsBar;
